<template>
  <div class="filter-box d-flex align-start">
    <div class="search-box">
      <label class="filter-label">Search</label>
      <div class="d-flex">
        <input type="text" v-model="search" @keypress.enter="getFlights" :disabled="loading" />
        <!-- <div class="search-icon" @click="getFlights">
          <i class="fas fa-search"></i>
        </div> -->
      </div>
    </div>

    <div class="date-box">
      <label class="filter-label">Booking Date</label>
      <div class="d-flex">
        <datepicker
          :format="calendarFormat"
          class="datepicker small inline fl-filter"
          v-model="booking.from"
          v-on:input="changeDate('from')"
          :disabled-picker="loading"
          :clear-button="true"
          :input-class="{'datepicker-empty':error.booking.from}"
          :placeholder="$t('transactions.filter.from')"
        ></datepicker>
        <datepicker
          :format="calendarFormat"
          class="datepicker small inline fl-filter"
          v-model="booking.to"
          v-on:input="changeDate('to')"
          :disabled-picker="loading"
          :clear-button="true"
          :input-class="{'datepicker-empty':error.booking.to}"
          :placeholder="$t('transactions.filter.to')"
        ></datepicker>
      </div>
      <transition name="slide-up">
        <div class="error-msg" v-show="!!error.message.bookingDate">
          {{ error.message.bookingDate }}
        </div>
      </transition>
    </div>

    <div class="date-box">
      <label class="filter-label">Travelling Date</label>
      <div class="d-flex">
        <datepicker
          :format="calendarFormat"
          class="datepicker small inline fl-filter"
          v-model="travel.from"
          v-on:input="changeDate('travelFrom')"
          :disabled-picker="loading"
          :clear-button="true"
          :input-class="{'datepicker-empty':error.travel.from}"
          :placeholder="$t('transactions.filter.from')"
        ></datepicker>
        <datepicker
          :format="calendarFormat"
          class="datepicker small inline fl-filter"
          v-model="travel.to"
          v-on:input="changeDate('travelTo')"
          :disabled-picker="loading"
          :clear-button="true"
          :input-class="{'datepicker-empty':error.travel.to}"
          :placeholder="$t('transactions.filter.to')"
        ></datepicker>
      </div>
      <transition name="slide-up">
        <div class="error-msg" v-show="!!error.message.travelDate">
          {{ error.message.travelDate }}
        </div>
      </transition>
    </div>

    <div>
      <label class="filter-label">Status</label>
      <select v-model="status" class="status" :disabled="loading">
        <option value="">All</option>
        <option value="UPCOMING">Upcoming</option>
        <option value="COMPLETED">Completed</option>
        <option value="CANCELED">Canceled</option>
        <option value="PENDING">Pending</option>
        <option value="STATUS7">Status7</option>
      </select>
    </div>

    <div class="search-btn-box d-flex">
      <div class="button cta success small search-btn" @click="getFlights">
        <span>SEARCH</span>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'filter',
  components: { datepicker },
  data () {
    return {
      search: '',
      booking: {
        from: '',
        to: ''
      },
      travel: {
        from: '',
        to: ''
      },
      status: '',
      error: {
        booking: {
          from: '',
          to: ''
        },
        travel: {
          from: '',
          to: ''
        },
        message: {
          bookingDate: '',
          travelDate: ''
        }
      }
    }
  },
  computed: {
    flights () { return this.$store.state.flights },
    loading: {
      get () { return this.flights.loading },
      set (x) { this.$store.commit('flights/setListData', {loading: x}) }
    }
  },
  methods: {
    getFlights () {
      let self = this
      if (self.loading || self.error.message.bookingDate || self.error.message.travelDate) return
      self.loading = true

      let param = {
        token: self.$store.state.session.sessionToken,
        pageNum: self.flights.currentPage,
        pageSize: self.flights.perPage,
        order: 'createTime',
        desc: true,
        paging: 1
      }

      if (self.search) param.search = self.search
      if (self.status) param.status = self.status

      if (self.booking.from && self.booking.to) {
        let from = moment(self.booking.from)
        from = moment(`${from.format('MM/DD/YYYY')} 00:00AM`, 'MM/DD/YYYY hh:mmA').format('X')
        let to = moment(self.booking.to)
        to = moment(`${to.format('MM/DD/YYYY')} 23:59PM`, 'MM/DD/YYYY hh:mmA').format('X')

        param.bookedSince = from
        param.bookedUntil = to
      }
      if (self.travel.from && self.travel.to) {
        let from = moment(self.travel.from)
        from = moment(`${from.format('MM/DD/YYYY')} 00:00AM`, 'MM/DD/YYYY hh:mmA').format('X')
        let to = moment(self.travel.to)
        to = moment(`${to.format('MM/DD/YYYY')} 23:59PM`, 'MM/DD/YYYY hh:mmA').format('X')

        param.pickupSince = from
        param.pickupUntil = to
      }

      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/get`, param, res => {
        let total = 0
        if (res.paging && res.paging.total) total = res.paging.total
        this.$store.commit('flights/setListData', {maxList: total})

        if (res.error) {
          self.$store.commit('flights/setListData', {list: []})
          self.loading = false
          return
        }

        let list = []
        res.list.forEach(f => {
          let origin = {
            airportCode: f.originAirportCode,
            airportName: f.originAirportName,
          }
          let destination = {
            airportCode: f.destAirportCode,
            airportName: f.destAirportName,
          }
          let paxName = '--'
          if (f.paxFirstName || f.paxLastName) paxName = `${f.paxFirstName} ${f.paxLastName}`
          list.push({
            id: f.id,
            bookingId: f.bookingId,
            created: moment(f.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
            origin: origin,
            destination: destination,
            status: f.status,
            paxName: paxName,
            rsvp1: f.rsvpId1,
            rsvp2: f.rsvpId2,
            isRefundable: f.isRefundable
          })
        })
        self.$store.commit('flights/setListData', {list: list})
        self.loading = false
      })
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    changeDate (type) {
      let format = 'MM/DD/YYYY'
      let from = ''
      let to = ''

      // Moment Setup
      if (type === 'from') {
        from = moment(this.booking.from)
        if (this.booking.to) { to = moment(this.booking.to) }
      } else if (type === 'to') {
        to = moment(this.booking.to)
        if (this.booking.from) { from = moment(this.booking.from) }
      } else if (type === 'travelFrom') {
        from = moment(this.travel.from)
        if (this.travel.to) { to = moment(this.travel.to) }
      } else {
        to = moment(this.travel.to)
        if (this.travel.from) { from = moment(this.travel.from) }
      }

      // Validation
      if (['from', 'to'].indexOf(type) > -1) {
        this.error.message.bookingDate = ''
        if (this.booking.from === '' && this.booking.to === '') {
          this.error.booking.from = false
          this.error.booking.to = false
          return
        }
        if (this.booking.from === '' || this.booking.to === '') {
          if (type === 'from') { this.error.booking.to = true }
          else { this.error.booking.from = true }
          this.error.message.bookingDate = this.$t('transactions.filter.emptyDate')
          return
        }
        if (from && to && from.format('x') > to.format('x')) {
          this.error.booking.from = true
          this.error.booking.to = true
          this.error.message.bookingDate = this.$t('transactions.filter.invalidDateRange')
          return
        }
        this.error.booking.from = false
        this.error.booking.to = false
      } else if (['travelFrom', 'travelTo'].indexOf(type) > -1) {
        this.error.message.travelDate = ''
        if (this.travel.from === '' && this.travel.to === '') {
          this.error.travel.from = false
          this.error.travel.to = false
          return
        }
        if (this.travel.from === '' || this.travel.to === '') {
          if (type === 'travelFrom') { this.error.travel.to = true }
          else { this.error.travel.from = true }
          this.error.message.travelDate = this.$t('transactions.filter.emptyDate')
          return
        }
        if (from && to && from.format('x') > to.format('x')) {
          this.error.travel.from = true
          this.error.travel.to = true
          this.error.message.travelDate = this.$t('transactions.filter.invalidDateRange')
          return
        }
        this.error.travel.from = false
        this.error.travel.to = false
      }
      // this.getFlights()
    },
    next () {

    },
    prev () {
      
    }
  },
  mounted () {
    this.getFlights()
  }
}
</script>

<style lang="scss" scoped>
.filter-box{
  padding: 10px 20px;
  gap: 15px;
}
.filter-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}
.search-box{
  height: 80px;

  input{
    width: 200px!important;
    margin-top: 0;
    line-height: 1;
    font-size: 14px;
    border-radius: 4px 0 0 4px;
    padding: 0 10px;
    line-height: 38px;
    height: 38px;
  }
  .search-icon{
    height: 38px;
    padding: 10px;
    background: #26D97A;
    color: #fff;
    border-radius: 0 4px 4px 0;
    cursor: pointer;

    i{
      font-size: 18px;
    }
    &:hover{
      background: #2aa764;
    }
  }
}

.status{
  max-width: 140px;
  height: 38px;
  padding: 0 8px;
}

.error-msg{
  color: #ff6115;
  font-size: 14px;
}

.search-btn-box{
  flex-grow: 1;
}
.search-btn{
  margin-top: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Flights/Filter.vue